import { render, staticRenderFns } from "./MlbDailyLineups.vue?vue&type=template&id=39219067&scoped=true"
import script from "./MlbDailyLineups.vue?vue&type=script&lang=js"
export * from "./MlbDailyLineups.vue?vue&type=script&lang=js"
import style0 from "./MlbDailyLineups.vue?vue&type=style&index=0&id=39219067&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39219067",
  null
  
)

export default component.exports